import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/milk-secretion', label: '奶水分泌' },
    { to: '/category/feeding-positions', label: '哺乳姿势' },
    { to: '/category/milk-boosting', label: '追奶技巧' },
    { to: '/category/weaning', label: '断奶过渡' },
    { to: '/about', label: '关于我们' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 max-w-7xl mx-auto">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap"
          >
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-full">
              <i className="ri-drop-fill text-background-50 text-lg"></i>
            </div>
            <span className={`font-heading text-xl transition-colors ${scrolled ? 'text-foreground-900' : 'text-foreground-50'}`}>
              奶水动画
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-3 py-2 text-sm rounded-lg transition-colors whitespace-nowrap ${
                  location.pathname === link.to
                    ? 'bg-primary-100 text-primary-700 font-medium'
                    : scrolled
                    ? 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                    : 'text-foreground-50/90 hover:text-foreground-50 hover:bg-white/10'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg transition-colors ${
              scrolled ? 'text-foreground-700 hover:bg-background-100' : 'text-foreground-50 hover:bg-white/10'
            }`}
            aria-label="菜單"
          >
            <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70">
            <div className="px-4 py-3 flex flex-col gap-1">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`px-3 py-2.5 text-sm rounded-lg transition-colors ${
                    location.pathname === link.to
                      ? 'bg-primary-100 text-primary-700 font-medium'
                      : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}